import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "version-layout" }
const _hoisted_2 = { class: "news-config" }
const _hoisted_3 = { class: "news-time" }
const _hoisted_4 = { class: "has-version" }
const _hoisted_5 = { class: "version-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "news-list" }
const _hoisted_8 = ["onMouseenter", "onClick", "innerHTML"]

import { ref, watchEffect, onMounted, nextTick } from "vue";
import Loading from "@/components/Loading/index.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'VersionLayout',
  props: /*@__PURE__*/_mergeModels([
  "currentVersion",
  "currentNews",
  "totalPeriod",
  "totalVersion",
  "articleList",
  "hasPermission",
  "homeRightLoading",
], {
    "timeValue": {},
    "timeValueModifiers": {},
    "currentMonth": {},
    "currentMonthModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["changeVersion", "openInfo", "changePeriod"], ["update:timeValue", "update:currentMonth"]),
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const timeValue = _useModel(__props, "timeValue");
const currentMonth = _useModel(__props, "currentMonth");
const currentArticleId = ref("");
//处理月份中不存在期次的日期，设置时间筛选框这些日期不可选择
const disabledDate = (time) => {
  // 标准化日期格式为时间戳（去除时分秒）
  const normalizeDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return isNaN(date.getTime())
      ? null
      : new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  };
  // 预处理禁用的日期
  const disabledDateTimestamps = props.totalPeriod
    ?.map(normalizeDate)
    .filter((timestamp) => timestamp !== null);

  const normalizedTime = new Date(time).setHours(0, 0, 0, 0);
  return !disabledDateTimestamps?.includes(normalizedTime);
};

//切换期次
const changePeriod = (type) => {
  emits("changePeriod", type);
};

//切换日报版本
const change = (item: number) => {
  emits("changeVersion", item);
};

//打开报纸详情
const toInfo = (item: Object) => {
  emits("openInfo", item);
};
//打开时间面板触发的函数
const openPanel = () => {
  console.log("面板打开了");
  nextTick(() => {
    const headerLabels = document.querySelectorAll(
      ".el-date-picker__header-label"
    );

    headerLabels.forEach((label) => {
      // 阻止点击事件
      label.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      // 可选：禁用鼠标交互
      label.style.pointerEvents = "none";
      label.style.cursor = "default";
    });
  });
};
//切换面板月份触发的函数
const handlePanelChange = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const currentTime = `${year}-${month}-01`;
  console.log("currentTime", currentTime);
  currentMonth.value = `${year}-${month}`;
};

watchEffect(() => {});
onMounted(() => {
  const headerLabels = document.querySelectorAll(
    ".el-date-picker__header-label"
  );

  headerLabels.forEach((label) => {
    // 阻止点击事件
    label.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "right-title" }, "科技日报", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_date_picker, {
          modelValue: timeValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeValue).value = $event)),
          type: "date",
          placeholder: "选择时间",
          size: "large",
          clearable: false,
          format: "YYYY年MM月DD日  dddd",
          "disabled-date": disabledDate,
          onPanelChange: handlePanelChange,
          onVisibleChange: openPanel,
          "popper-options": {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [30, 10], // [水平偏移, 垂直偏移]
                },
              },
            ],
          }
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_space, { wrap: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "lastIssue",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changePeriod('pre')))
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("上一期")
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_el_button, {
            class: "nextIssue",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changePeriod('next')))
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("下一期")
            ])),
            _: 1,
            __: [5]
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Loading, {
        loading: props.homeRightLoading
      }, null, 8, ["loading"]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.totalVersion, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["version-item", {
            'active-item': item.id === __props.currentVersion?.id,
            'long-name': item.editionName.length > 21,
          }]),
            key: index,
            onClick: ($event: any) => (change(item))
          }, _toDisplayString(item.editionName), 11, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.articleList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["news-item", [currentArticleId.value == item?.id && 'active-news-item']]),
            onMouseenter: 
            () => {
              currentArticleId.value = item?.id;
            }
          ,
            onMouseleave: _cache[3] || (_cache[3] = 
            () => {
              currentArticleId.value = '';
            }
          ),
            key: index,
            onClick: ($event: any) => (toInfo(item)),
            innerHTML: 
            item.title &&
            item.title.replace(/<p\b[^>]*>|<\/p>/g, (match) =>
              match.startsWith('</') ? '</div>' : '<div>'
            )
          
          }, null, 42, _hoisted_8))
        }), 128))
      ])
    ])
  ]))
}
}

})